<template>
  <div v-if="!queuelink" :id="pos()">

    <!-- {{ queues }} {{ debug }} -->

    <div class="queue" v-if="debug">  <!-- will need to check also if input -->
      <v-chip
        small
        close
        close-icon="ui-circle-cross-filled"
        outlined
        :key="index"
        @click="getContent(qid, item.shortname)"
        >{{ qid }}</v-chip
      >
      <v-btn
        small
        icon
        v-if="debug && !paused[item.shortname]"
        @click="pauseQueue(item.shortname)"
        class="pause-queue"
      >
        <span style="color: white">&#9616;&#9616;</span>
      </v-btn>
      <v-btn
        small
        icon
        v-if="debug && paused[item.shortname]"
        @click="resumeQueue(item.shortname)"
        class="pause-queue"
      >
        <apio-icon name="ui-play" lightModeColour="white" darkModeColour="white" />
      </v-btn>

      <v-dialog
        title="Queue Item"
        max-width="800"
        v-model="qmodalKeys[pos(skey)]"
        :id="'qmodal-' + prefix + '-' + pos(skey)"
      >
        <v-card flat>
          <HeaderPanel header-text="Queue Item">
            <v-btn
              x-small
              class="p-0 m-0"
              slot="header-right"
              text
              @click.native="$set(qmodalKeys, pos(skey), false)"
            >
              <v-icon size="16">fa-times</v-icon>
            </v-btn>
          </HeaderPanel>
          <v-card-text>
            <div class="step-modal__row">
              <v-textarea @change="changeQitem" rows="13" v-model="qitem" />
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div v-else-if="simulator">
      <div class="queue queue-step__simulator">
        <div class="queue-step__simulator-steps">
          <template v-if="simbundle[prefix + ':' + skey]">
            <v-chip
              v-for="(payload, index) in simbundle[prefix + ':' + skey]"
              color="white"
              small
              class="queue-step__simulator-chip extra-tiny-extra-bold"
              :key="payload.hash"
              @click:close="
                simDelFromQueue(prefix + ':' + skey, index, payload.hash)
              "
            >
              <apio-icon v-if="payload.pinned" @click.native="simPinToggle(prefix + ':' + skey, index)" name="ui-pin-filled" size="14" lightModeColour="white" darkModeColour="white" />
              <apio-icon v-else @click.native="simPinToggle(prefix + ':' + skey, index)" name="ui-pin-outline" size="14" lightModeColour="white" darkModeColour="white" />
              <div
                @click="
                  qindex = index;
                  qitem = getSimPayload(prefix, skey, index);
                  $set(qmodalKeys, pos(), true);
                "
              >
                {{ payload.hash }}
              </div>
              <apio-icon
                class="queue-step__simulator-chip-close"
                size="16"
                name="ui-circle-cross-filled"
                lightModeColour="purple"
                darkModeColour="purple"
                @click.native="
                  simDelFromQueue(prefix + ':' + skey, index, payload.hash)
                "
              />
            </v-chip>
          </template>
        </div>
        <div class="queue-step__simulator-close">
          <apio-icon
            @click.native="simEmptyQueue(prefix + ':' + skey)"
            name="ui-circle-cross-line"
            lightModeColour="white"
            darkModeColour="white"
            size="20"
          />
        </div>
      </div>
    </div>
    <div v-else style="height: 8px"></div>

    <v-dialog
      max-width="600px"
      class="payload"
      title="Payload"
      v-model="showPayload"
      :id="'modal-' + prefix + '-' + pos(skey)"
    >
      <v-card height="50vh">
        <v-toolbar flat color="apioshade3" class="white--text payload__toolbar">
          <div class="white--text payload__title">Payload</div>
          <v-spacer></v-spacer>

          <apio-button
            button-type="get-started"
            button-size="small"
            @click="showPayload = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
        </v-toolbar>
        <v-card-text class="payload__content mt-4 pb-0">
          <apio-icon
            size="16"
            class="payload__copy-icon ml-1"
            @click.native="copyToClipboard(payload)"
            lightModeColour="cyan"
            name="ui-copy"
          ></apio-icon>
          <v-textarea outlined @change="changeQitem" rows="8" v-model="payload" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <apio-snackbar
      :text="snackBarText"
      :status="snackBarStatus"
      :snackbar="snackbar"
      @close="snackbar = false"
    />
  </div>
</template>

<script>
import * as clipboard from "clipboard-polyfill/text";
import { mapState } from "vuex";

export default {
  name: "Queue",
  props: [
    "item",
    "skey",
    "prefix",
    "simbundle",
    "simulator",
    "debug",
    "queues",
    "paused",
  ],
  data: () => ({
    extra: "",
    qstep: "",
    qitemKey: "",
    qitemIndex: 0,
    qitem: "",
    qindex: 0,
    qmodal: false,
    modal: false,
    selectedStep: {},
    modalKeys: {},
    qmodalKeys: {},
    showPayload: false,
    payload: "",
    snackbar: false,
    snackBarText: "",
    snackBarStatus: null,
  }),
  components: {
    HeaderPanel: () => import("@/components/HeaderPanel/HeaderPanel.vue"),
  },
  computed: {
    ...mapState({
      datamapper: (state) => state.datamapper,
    }),
    queuelink: function () {
      return typeof this.simbundle[this.prefix + ":" + this.skey] == "string";
    },
  },
  methods: {
    async copyToClipboard(val) {
      const vm = this;
      await clipboard.writeText(val).then(
        function () {
          vm.snackBarText = "Copied to clipboard";
          vm.snackBarStatus = "success";
          vm.snackbar = true;
        },
        function () {
          vm.snackBarText = "Could not copy value to the clipboard";
          vm.snackBarStatus = "success";
          vm.snackbar = true;
        }
      );
    },
    changeQitem(v) {
      this.simbundle[this.qitemKey][this.qitemIndex].payload = v;
    },
    pos() {
      return (this.prefix ? this.prefix + "." : "") + this.skey;
    },
    getSimPayload(prefix, key, index) {
      if (prefix == "steps" && key == -1) {
        prefix = "input";
        key = -1;
      }
      this.qitemKey = prefix+':'+key;
      this.qitemIndex = index;
      if (this.simbundle[prefix + ":" + key] == undefined) {
        return null;
      }
      const qitem = this.simbundle[prefix + ":" + key][index].payload;
      this.payload = qitem;
      this.showPayload = true;
      this.$store.dispatch("updateQueueItem", JSON.parse(qitem));
      return qitem;
    },
    getContent(qid, shortname) {
      this.$root.$emit("getcontent", {
        qid: qid,
        shortname: shortname,
      });
    },
    pauseQueue(shortname) {
      this.$root.$emit("pausequeue", {
        shortname: shortname,
      });
    },
    resumeQueue(shortname) {
      this.$root.$emit("resumequeue", {
        shortname: shortname,
      });
    },
    simEmptyQueue(k) {
      this.$root.$emit("sim-empty", {
        key: k,
      });
    },
    simDelFromQueue(k, id, queue) {
      this.$root.$emit("sim-delfrom", {
        key: k,
        id: id,
        queue: queue,
      });
    },
    simDelete(key, index) {
      this.$root.$emit("sim-delete", {
        key: self.prefix + ":" + key,
        index: index,
      });
    },
    simPinToggle(key, index) {
      this.$root.$emit("sim-pintoggle", {
        key: key,
        index: index,
      });
    },
    simDisable() {
      this.simulator = false;
      this.simbundle = {};
    },
  },
};
</script>
<style scoped lang="scss">
div[id^="input."] {
  @media screen and (min-width: 1005px) {
    margin-right: 24px;
  }
}

.payload {
  overflow: hidden;

  &__title {
    font-size: var(--font-h2-size);
    font-weight: var(--font-semi-bold);
  }
  &__copy-icon {
    cursor: pointer;
    position: absolute;
    right: 48px;
    top: 90px;
    z-index: 9;
  }
}

.queue {
  align-items: center;
  height: fit-content;
  min-height: 40px;
  overflow: hidden;
  display: flex;
  padding: 2px 0;
  margin: 0 0 0 8px;
  background: var(--apio-magenta);
  box-shadow: inset 0px 10px 8px -10px #444, inset 0px -10px 8px -10px #444;

  &-step {
    &__simulator-steps {
      width: calc(100% - 32px);
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      max-height: 100px;
      margin: 4px 0 4px 4px;
    }

    &__simulator-close {
      cursor: pointer;
      width: 24px;
      margin: auto auto;
      max-height: 100px;
    }

    &__simulator-chip {
      cursor: pointer;
      max-width: 100px;
      padding: 0 4px;
      margin: 2px !important;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: var(--font-extra-tiny-size);
    }

    &__simulator-chip-close {
      cursor: pointer;
    }
  }
}
</style>
